export const DEFAULT_ROOT_SELECTOR = "body";

export function normalizeSelectors(selectors?: readonly string[] | null): string[] {
  const normalized = (selectors ?? [])
    .map((selector) => (typeof selector === "string" ? selector.trim() : ""))
    .filter((selector) => selector.length > 0);

  return normalized.length > 0 ? normalized : [DEFAULT_ROOT_SELECTOR];
}
